module.exports = __webpack_public_path__ + "static/media/unccLogo.ef757e1c.png";